import { __ } from '@wordpress/i18n'
import SpecificSelectControl from './SpecificSelectControl';
import { useMemo } from 'react';
import { addBtn, removeBtn } from '../Icons';

export default function DisplayConditionsSelectControl({ value = {}, metaKey, updateEditedMeta  }) {
    const rules = Array.isArray(value?.rule) && value.rule.length > 0 ? value.rule : [''];

    const updateRules = (newRules) => {
        const cleanedMeta = { ...value };

        if (!newRules.includes('specifics')) {
            cleanedMeta.specific = [];
            cleanedMeta.specificText = [];
        }

        updateEditedMeta (metaKey, {
            ...cleanedMeta,
            rule: newRules,
        });
    };

    const handleChange = (index, selected) => {
        const updated = [...rules];
        updated[index] = selected;
        updateRules(updated);
    };

    const handleAdd = () => updateRules([...rules, '']);
    const handleRemove = (index) => {
        if (rules.length <= 1) return;
        const updated = [...rules];
        updated.splice(index, 1);
        updateRules(updated);
    };

    const ListDisplayConditions = useMemo( ()=> {
        return Object.entries(responsive_addons_site_builder.displayRules).map(([groupKey, group]) => (
           <optgroup key={groupKey} label={group.label}>
               {Object.entries(group.value).map(([val, label]) => {
                   const isSelected = rules.includes(val);
                   return (
                       <option key={val} value={val} disabled={isSelected}>
                           {label}
                       </option>
                   );
               })}
           </optgroup>
       ));
    }, [rules]);

    return (
        <div>
            {rules.map((selected, index) => (
                <div key={index} className="responsive-sb-display-rules flex justify-between">
                    <div className="mb-2 w-[calc(100%-100px)]">
                        <select
                            id={`select-${metaKey}-${index}`}
                            title={__("Responsive Site Builder Display Conditions", "responsive-addons")}
                            value={selected}
                            onChange={(e) => handleChange(index, e.target.value)}
                            className="responsive-sb-admin-select"
                        >
                            <option value="">{__("— Select —", "responsive-addons")}</option>
                            {ListDisplayConditions}
                        </select>

                        {'specifics' === selected && (
                            <SpecificSelectControl
                                value={value}
                                metaKey={metaKey}
                                updateEditedMeta ={updateEditedMeta }
                            />
                        )}
                    </div>

                    <div className="flex gap-[10px] items-start mt-[3px]">
                        <span onClick={handleAdd} className="cursor-pointer" title={__("Add", "responsive-addons")}>
                            {addBtn}
                        </span>
                        { rules.length > 1 &&
                            <span
                                onClick={() => handleRemove(index)}
                                className="cursor-pointer"
                                title={__("Remove", "responsive-addons")}
                            >
                                {removeBtn}
                            </span>
                        }
                    </div>
                </div>
            ))}
        </div>
    );
}
